import { fetchGet, fetchCA } from 'helpers/utils'
import { getParam } from '../../helpers/parameters'

export const fetchTutorialStepsApi = async (tutorialId) => {
  const contentApiUrl = await getParam('contentApiUrl')
  return fetchGet(`${contentApiUrl}/tutorialsteps`, { tutorialId })
}

export const fetchTutorialListApi = async (phoneId) => {
  const contentApiUrl = await getParam('contentApiUrl')
  return fetchGet(`${contentApiUrl}/tutorials`, { phoneId })
}

export const apiFetchTutorial = (id) => fetchCA(`/tutorials/${id}`)
